import { render, staticRenderFns } from "./ActionLogCard.vue?vue&type=template&id=ef3baa1a&scoped=true"
import script from "./ActionLogCard.vue?vue&type=script&lang=js"
export * from "./ActionLogCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3baa1a",
  null
  
)

export default component.exports